import React, { useEffect, useState } from "react";
import { Breadcrumb, Layout, Menu, theme } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import Privacy from "../pages/privacyPolicies/privacyPolicies";
import {
  homeIcon,
  redTrash,
  businessIcon,
  userSupportIcon,
  serviceIcon,
  userIcon,
  privacyIcon,
  destinationIcon,
  aboutIcon,
  contactIcon,
  busIcon,
} from "../assets";
import "./layout.css";
import Header2 from "../components/header/header";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Root from "../pages/Roots/RootsList";
import UserLists from "../pages/userList/userList";
import About from "../pages/aboutUs/aboutUs";
import Loader from "../components/loader/loader";
import { GreenNotify, RedNotify } from "../helper/helper";
import Contact from "../pages/ContactUs/contactUs";
import LandingPage from "../pages/landingPage/landingPage";
import Stage from "../pages/Stages/stagesList";
import Business from "../pages/businessDirectory/businessDList";
import TermsOfUse from "../pages/termsOfUse/termsOfUse";
import UserSupport from "../pages/userSupport/userSupportList";
const { Header, Content, Footer, Sider } = Layout;

const LayoutDashboard = () => {
  const [isloading, setIsLoading] = useState(false);
  const [isOrganizerModalVisible, setIsOrganizerModalVisible] = useState(false);
  const [isPrivacyModalVisible, setIsPrivacyModalVisible] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const logOut = () => {
    GreenNotify("Logout successful");
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    return () => setIsLoading(false);
  }, []);

  const currentPath = location.pathname;
  const routeToKey = {
    "/users-list": "1",
    "/stages": "2",
    "/business-directory": "3",
    "/deliveries": "4",
    "/roots": "5",
    "/interests": "6",
    "/userSupports": "7",
    "/termsOfUse": "12",
    "/feedbacks": "9",
    "/privacy": "10",
    "/about-us": "13",
    "/contact-us": "14",
  };

  const currentKey = routeToKey[currentPath];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Loader loading={isloading} />
      <Sider style={{ background: "#0B1B2D" }} width={280}>
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
            color: "white",
            fontSize: "3rem",
            scrollBehavior: "smooth",
            position: "sticky",
            borderBottom: "10px",
            height: "250px",
          }}
        >
          <h5>GOODWAY</h5>
        </div>
        <Menu
          style={{ marginTop: "30px" }}
          inlineCollapsed={true}
          theme="dark"
          defaultSelectedKeys={["1"]}
          mode="inline"
        >
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/user-list")}
            icon={<img className="side-bar-icon" src={userIcon} />}
            key="1"
            className={currentKey === "1" ? "active-menu-item" : ""}
          >
            Users
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/routes")}
            icon={<img className="side-bar-icon" src={destinationIcon} />}
            key="5"
            className={currentKey === "5" ? "active-menu-item" : ""}
          >
            Routes
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/stages")}
            icon={<img className="side-bar-icon" src={busIcon} />}
            key="2"
            className={currentKey === "2" ? "active-menu-item" : ""}
          >
            Stages
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/business-directory")}
            icon={<img className="side-bar-icon" src={businessIcon} />}
            key="3"
            className={currentKey === "3" ? "active-menu-item" : ""}
          >
            Point Of Interest
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/userSupports")}
            icon={<img className="side-bar-icon" src={userSupportIcon} />}
            key="7"
            className={currentKey === "7" ? "active-menu-item" : ""}
          >
            User Support
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/about-us")}
            icon={<img className="side-bar-icon" src={aboutIcon} />}
            key="13"
            className={currentKey === "13" ? "active-menu-item" : ""}
          >
            About US
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/contact-us")}
            icon={<img className="side-bar-icon" src={contactIcon} />}
            key="14"
            className={currentKey === "14" ? "active-menu-item" : ""}
          >
            Contact Us
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/termsOfUse")}
            icon={<img className="side-bar-icon" src={serviceIcon} />}
            key="12"
            className={currentKey === "12" ? "active-menu-item" : ""}
          >
            Terms Of Use
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/privacy-policy")}
            icon={<img className="side-bar-icon" src={privacyIcon} />}
            key="10"
            className={currentKey === "10" ? "active-menu-item" : ""}
          >
            Privacy Policy
          </Menu.Item>

          <Menu.Item
            onClick={logOut}
            key="11"
            icon={<LogoutOutlined className="side-bar-icon" />}
          >
            Log Out
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header2 />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/termsOfUse" element={<TermsOfUse />} />
            <Route path="/routes" element={<Root />} />{" "}
            <Route path="/business-directory" element={<Business />} />
            <Route path="/stages" element={<Stage />} />
            <Route path="/user-list" element={<UserLists />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/userSupports" element={<UserSupport />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
